export const settings = {
    "title": "Health 51",
    "description": "Health 51",
    "apiUrl": "https://health51.ckd-software.it/api",
    "ckdPath": "https://health51.ckd-software.it"
}